// extracted by mini-css-extract-plugin
module.exports = {"glacierCrowdfunding":"crowdfunding_glacierCrowdfunding__B04x3"};